module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.6116/img/business-types/nonprofit-education.png"